import { request } from "@/api/request"
import { getLoginUserId } from "@/utils/auth"

export function fetchCustomerList(payload) {
  return request.post("/mgm-crm-api/customer/list", payload).then(r => r.data)
}

export function checkInCustomer(payload = {}) {
  return request.post("/mgm-crm-api/customer/check-in", payload).then(r => r.data)
}

export function cancelBooking(id) {
  return request.post(`/mgm-crm-api/customer/cancel/${id}`, {}).then(r => r.data)
}

export function deleteCustomer(studentId) {
  return request.post(`/mgm-crm-api/customer/delete/${studentId}`, {}).then(r => r.data)
}

export function payDeposit(payload) {
  return request.post("/mgm-crm-api/customer/pay-deposit", payload).then(r => r.data)
}

/** 到店结果 */
export function checkInResultCustomer(payload) {
  return request.post("/mgm-crm-api/customer/check-in-result", payload).then(r => r.data)
}

export function completeCustomer(payload) {
  return request.post("/mgm-crm-api/customer/complete", payload).then(r => r.data)
}

/** 确认开课 */
export function confirmClassCustomer(payload) {
  return request.post("/mgm-crm-api/customer/confirm-class", payload).then(r => r.data)
}

/** 提交不在学状态 */
export function submitCourseStatus(payload) {
  return request.post("/mgm-crm-api/customer/submit-course-status", payload).then(r => r.data)
}

/** 激活学员 */
export function activateCustomer(payload) {
  return request.post("/mgm-crm-api/customer/activate", payload).then(r => r.data)
}

export function assignTeacher(payload) {
  return request.post("/mgm-crm-api/customer/assigned-teacher", payload).then(r => r.data)
}

/** 报英皇课 */
export function customerAbrsm(payload) {
  return request.post("/mgm-crm-api/customer/abrsm", payload).then(r => r.data)
}

/** 启蒙REN续费 */
export function customerRenew(payload) {
  return request.post("/mgm-crm-api/customer/renew", payload).then(r => r.data)
}

/** 启蒙8次课续费 */
export function customerRenew8(payload) {
  return request.post("/mgm-crm-api/customer/renew8", payload).then(r => r.data)
}

/** 杂费 */
export function customerOther(payload) {
  return request.post("/mgm-crm-api/customer/other", payload).then(r => r.data)
}

/** 新增学员 */
export function createCustomerInput(payload) {
  const staffId = getLoginUserId() || undefined
  return request
    .post("/mgm-crm-api/customer/input", { ...payload, staffId })
    .then(r => r.data)
}

/** 新增学员前校验手机号是否已存在（true=已存在） */
export function validateCustomerMobile(mobile) {
  return request.post(`/mgm-crm-api/customer/validate/${encodeURIComponent(mobile)}`).then(r => r.data)
}

/** 邀约：设置邀约时间 */
export function bookingCustomer(payload) {
  return request.post("/mgm-crm-api/customer/booking", payload).then(r => r.data)
}

/** 再邀约 */
export function againBookingCustomer(payload) {
  return request.post("/mgm-crm-api/customer/again-booking", payload).then(r => r.data)
}

/** 拓课 */
export function expansionCustomer(payload) {
  return request.post("/mgm-crm-api/customer/expansion", payload).then(r => r.data)
}

/** 编辑学员 */
export function updateCustomer(payload) {
  return request.post("/mgm-crm-api/customer/update", payload).then(r => r.data)
}

/** 编辑续费记录 */
export function updateRenew(payload) {
  return request.post("/mgm-crm-api/customer/update-renew", payload).then(r => r.data)
}

/** 字典项查询，dictTypeId 如渠道字典100 */
export function fetchDictionary(dictTypeId) {
  return request.post(`/mgm-crm-api/dictionary/query/${dictTypeId}`, {}).then(r => r.data)
}

/** 员工列表：返回字段常见为 { weName, id } */
export function fetchStaffList(payload) {
  return request.post("/mgm-crm-api/staff/query", payload).then(r => r.data)
}

/** 当前登录员工信息（请求头 X-UserId / X-Userid） */
export function fetchStaffById() {
  return request.post("/mgm-crm-api/staff/query-by-id", {}).then(r => r.data)
}

/** 顶级中心列表：返回字段常见为 { weName, weId } */
export function fetchTopDepartments() {
  return request.post("/mgm-crm-api/department/query-top-departments", {}).then(r => r.data)
}

/** 全部成本归属（报销申请成本归属多选） */
export function fetchAllTopDepartments() {
  return request.post("/mgm-crm-api/department/query-all-top-departments", {}).then(r => r.data)
}

